import { LookupModelSearchEvent, DataSourceExecutionEvent, DataSourceAction, Snackbar, MainPageAccessor, ClickEvent } from "@mcleod/components";
import { AutogenLayoutTableProperty } from "./autogen/AutogenLayoutTableProperty";
import { Api, LogManager, ModelRow } from "@mcleod/core";
import { CommonDialogs } from "./CommonDialogs";

const log = LogManager.getLogger("common.TableProperty");
export class TableProperty extends AutogenLayoutTableProperty {
    private syncTable: boolean = false;
    private previousSharedState: String = null;

    /** This is an event handler for the beforeExecution event of sourceTableProperty. */
    sourceTablePropertyBeforeExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.UPDATE) {
            const changed = this.sourceTableProperty.hasChanged(false);
            if (changed) {
                const changedData = this.sourceTableProperty.activeRow.getChangedData() as Partial<any>;
                if (changedData != null && 'is_shared' in changedData) {
                    this.syncTable = true;
                    this.previousSharedState = event.data?.originalData?.is_shared;
                }
            }
        }
    }

    /** This is an event handler for the afterExecution event of sourceTableProperty. */
    async sourceTablePropertyAfterExecution(event: DataSourceExecutionEvent) {
        log.info("sourceTablePropertyAfterExecution", event.data, event.dataSource, event.filter);
        const row = this.sourceTableProperty?.activeRow as ModelRow;
        if (event.getAction() === DataSourceAction.UPDATE && this.syncTable && row != null) {
            const tableName = row.get("table_name");
            const progressSnack: Snackbar = Snackbar.showDownloadSnackbar(
                "Syncing Indexes",
                "Syncing indexes for table " + tableName,
                { targetPanel: MainPageAccessor.router, persist: true }
            );
            try {
                const response = await Api.post("common/table-index-recreate", { table_name: tableName }).then((response) => {
                    progressSnack.dismiss();
                    const success = response?.data?.[0]?.success;
                    const message = response?.data?.[0]?.message;
                    if (success) {
                        CommonDialogs.showMessage({ text: "Indexes for table " + tableName + " synced successfully", imageName: "disk", fontBold: true });
                    } else {
                        this.revertSharedState();
                        CommonDialogs.showMessage(message == null ? "" : message, "Indexes for table " + tableName + " failed to sync", { fontBold: true });
                    }
                });
            } catch (err) {
                progressSnack.dismiss();
                this.revertSharedState();
                CommonDialogs.showMessage({ text: "Indexes for table " + tableName + " failed to sync: " + err, imageName: "disk", fontBold: true });
            } finally {
                this.syncTable = false;
                this.previousSharedState = null;
            }
        }
    }

    private revertSharedState() {
        const row = this.sourceTableProperty?.activeRow as ModelRow;
        if (row != null && this.previousSharedState != null) {
            row.set("is_shared", this.previousSharedState);
            this.sourceTableProperty.post();
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxFieldName. */
    textboxFieldNameBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.table_name = this.sourceTableProperty.activeRow.get("table_name");
    }

    /** This is an event handler for the onClick event of textboxFieldName. */
    textboxFieldNameOnClick(event: ClickEvent) {
        // TODO - This is a workaround for the issue where the quick add textbox fails to maintain focus
        log.debug("event", event);
    }
}
